import 'zone.js'
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base'
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch'
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import { W3CTraceContextPropagator } from '@opentelemetry/core'
import { addSignalAttribute, init } from '@dash0/sdk-web'
import { Resource, resourceFromAttributes } from '@opentelemetry/resources'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'

export const setupDash0Tracing = () => {
  const otlpEndpoint = `${import.meta.env.VITE_DASH0_ENDPOINT || 'https://ingress.eu-west-1.aws.dash0.com'}/v1/traces`
  const otlpAuth = import.meta.env.VITE_DASH0_API_KEY || ''

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]: 'management-web-app',
    } as Resource['attributes']),
    spanProcessors: [
      new BatchSpanProcessor(
        new OTLPTraceExporter({
          url: otlpEndpoint,
          headers: {
            Authorization: `Bearer ${otlpAuth}`,
            'Dash0-Dataset': 'xeetr',
          },
        })
      ),
    ],
  })

  provider.register({
    contextManager: new ZoneContextManager(),
    propagator: new W3CTraceContextPropagator(),
  })

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        ignoreUrls: [/localhost:3000\/sockjs-node/, otlpEndpoint, /\/v1\/traces/],
        propagateTraceHeaderCorsUrls: ['.*'],
      }),
      new XMLHttpRequestInstrumentation({
        ignoreUrls: [/localhost:3000\/sockjs-node/, otlpEndpoint, /\/v1\/traces/],
      }),
    ],
  })

  return provider
}

export const initDash0Sdk = () => {
  try {
    init({
      endpoint: {
        url: import.meta.env.VITE_DASH0_ENDPOINT || 'https://ingress.eu-west-1.aws.dash0.com',
        authToken: import.meta.env.VITE_DASH0_API_KEY || '',
        dataset: 'xeetr',
      },
      serviceName: 'management-web-app',
      environment: import.meta.env.MODE === 'prod' ? 'production' : 'development',
      propagators: [
        {
          type: 'traceparent',
          match: [
            /localhost:3000/,
            /localhost:9000/,
            /.*\.execute-api\.eu-central-1\.amazonaws\.com/,
          ],
        },
      ],
    })

    addSignalAttribute('environment', import.meta.env.MODE === 'prod' ? 'production' : 'staging')

    return true
  } catch (error) {
    console.error('Dash0 SDK initialization failed:', error)
    return false
  }
}
